<template>
  <button
    type="button"
    role="button"
    aria-haspopup="true"
    aria-expanded="false"
    @click.stop="$store.commit('auth/OPEN', true)"
    class="outline-none e2e-login secondary--text"
  >
    Log In
  </button>
</template>

<script>
export default {
  name: "LoginButton",
};
</script>
